import { outlinedWarningAmber } from '@quasar/extras/material-icons-outlined';
import Notify from 'quasar/src/plugins/notify/Notify.js';
export class WarningMessage {
    static show(message) {
        Notify.create({
            type: 'warning',
            icon: outlinedWarningAmber,
            message: message,
            html: true,
            progress: true,
            position: 'top',
        });
    }
}
